import {
  AutocompleteInput,
    BooleanField,
    Datagrid,
    DateField,
    List,
    NumberField,
    ReferenceInput,
    TextField,
    TextInput,
  } from 'react-admin';


  export const searchFilters = [

    <TextInput
    source="email@ilike"
    label="Email"
    resettable
    alwaysOn
  />
    
  ];
  
  export const SubscriptionsList = () => {
    return (
    <List 
      filters={searchFilters}
      sort={{ field: 'id', order: 'DESC' }}
      >
      <Datagrid rowClick="edit" bulkActionButtons={false}>
        <NumberField source="id" />
        <TextField source="email" />
        <BooleanField source="active" />
        <BooleanField source="confirmed" />
        <DateField source="created_at" />
        <DateField source="unsubscribe_date" />
      </Datagrid>
    </List>
  );
    }
  